/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'navbar-arrow': {
    width: 8,
    height: 6,
    viewBox: '0 0 8 6',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M0 1.98L1.293.76 4 3.315 6.707.76 8 1.98 4 5.76 0 1.98z" _fill="#fff"/>'
  }
})
